import Immutable from 'immutable';
import ActionTypes from '../ActionTypes';
import createReducer from '../../util/createReducer';
import moment from 'moment';

function formatDate(date) {
  const dateFormat = 'DDMMM';
  return date.format(dateFormat).toUpperCase();
}

const initialState = Immutable.fromJS({
  arrival: null,
  departure: null,
  duration: 0,
  dateString: '',
  destination: '',
  vendorName: '',
  vendorURL: '',
  roomRates: '',
  amenityType: '',
  amenities: '',
});

export default createReducer(initialState, {
  [ActionTypes.RateQuote.updateDateRange](state, { string }) {
    const { startDate, endDate } = string;
    const duration = Math.floor(moment.duration(endDate - startDate).asDays());
    const dateString = `${formatDate(startDate)}-${duration}NT`;

    return state.merge({
      arrival: startDate.valueOf(),
      departure: endDate.valueOf(),
      duration,
      dateString,
    });
  },
  [ActionTypes.RateQuote.updateDateString](state, { string }) {
    const dateStringRE = /(\d{1,2})(\w{3})[\- ](\d+)[Nn][Tt]/;
    const match = dateStringRE.exec(string);

    if (match) {
      const [entry, day, month, duration] = match;
      const startDate = moment(`${day} ${month} ${moment().format('YYYY')}`);

      if (startDate < moment()) {
        startDate.add(1, 'years');
      }

      const endDate = moment(startDate).add(
        moment.duration(parseInt(duration), 'days'),
      );

      return state.merge({
        arrival: startDate.valueOf(),
        departure: endDate.valueOf(),
        duration: parseInt(duration),
        dateString: string,
      });
    }
    return state.merge({
      dateString: string,
    });
  },
  [ActionTypes.RateQuote.toggleDatePicker](state, { string }) {
    return state.set('showDatePicker', string);
  },
  [ActionTypes.RateQuote.updateString](state, { fieldName, value }) {
    return state.set(fieldName, value);
  },
});



// WEBPACK FOOTER //
// /src/store/reducers/RateQuote.js